









































































// tslint:disable:max-line-length
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import VatsAPI from '@/Shared/VatsAPI';
import VatsGoogleMap from '@/Shared/VatsGoogleMaps/VatsGoogleMap.vue';
import Multiselect from 'vue-multiselect';
import mixins from 'vue-typed-mixins';
import {mapGetters} from 'vuex';
import {TrackedDevice} from '@/Admin/VATSTracking/TrackedDevice';
import {DeviceTrackingData} from '@/Admin/VATSTracking/DeviceTrackingData';
import {TimeFrame} from '@/Admin/VATSTracking/TimeFrame';
import {AxiosRequestConfig} from 'axios';
import {Logger} from '@/Shared/Logger';
import {DateRange} from '@/Admin/VATSTracking/DateRange';
import {DeviceTrackingDataCollection} from '@/Admin/VATSTracking/DeviceTrackingDataCollection';
import LatLng = google.maps.LatLng;
import { getLocaleWithoutDialect } from '@/internationalization';

const allDevicesDeviceId: string = 'C190138C-AB2C-49EE-8C40-D2A48DA04754';

const DEFAULT_ICON: string = 'https://maps.gstatic.com/mapfiles/api-3/images/spotlight-poi2.png';
const TRACKING_ICON_FIRST: string = 'https://maps.gstatic.com/mapfiles/ridefinder-images/mm_20_green.png';
const TRACKING_ICON_DEFAULT: string = 'https://maps.gstatic.com/mapfiles/ridefinder-images/mm_20_blue.png';
const TRACKING_ICON_LAST: string = 'https://maps.gstatic.com/mapfiles/ridefinder-images/mm_20_red.png';

const VATSTrackingAdmin = mixins(LocationBasedMixin).extend({
    components: {
        VatsGoogleMap,
        Multiselect
    },
    data() {
        return {
            mapOptions: {} as google.maps.MapOptions,
            markers: [] as google.maps.Marker[],

            trackedDevices: [] as TrackedDevice[],
            selectedDevice: (null as any) as TrackedDevice,
            selectedTimeFrame: (null as any) as TimeFrame,
            availableTimeFrames: [] as TimeFrame[],

            selectedStartDate: new Date(),
            selectedEndDate: new Date(),
        };
    },
    computed: {
        ...mapGetters('loaderModule', ['loading'])
    },
    async mounted() {
        await this.init();
    },
    methods: {
        // region "Init methods"

        async init() {
            this.mapOptions = await this.getMapOptions();
            this.trackedDevices = await this.getTrackedDevices();
            this.availableTimeFrames = TimeFrame.AvailableTimeFrames;

            this.selectedStartDate = new Date();
            this.selectedEndDate = new Date();

            // prefill the map with all devices, current location
            this.selectedDevice = this.trackedDevices[0];
            this.selectedTimeFrame = this.availableTimeFrames[0];

            // set the map markers, center the map on the markers, and draw polylines between the markers
            await this.onUpdateMap();

            // set the Run Report link for the default device and time frame
            this.setRunReportLink(this.selectedDevice, this.getDateRange(this.selectedTimeFrame));

            return;
        },

        setRunReportLink(trackedDevice: TrackedDevice, dateRange: DateRange) {

            const link: HTMLElement | null = document.getElementById('runReportLink'); // or grab it by tagname etc

            if (link === null) {
                return;
            }

            if (trackedDevice.deviceID === allDevicesDeviceId) {
                // the report generation logic is too naive to understand "All".  It's looking for a device named "All".
                // if there really is a device named "All" we'll still be able to report on it because we're checking the device ID,
                // not the name.

                // "Disable" link by removing the href property
                link.setAttribute('href', '');
                return;
            }

            // https://localhost:44300/main/GPSGapReportExport.aspx
            // ?p1=5/1/2020 00:00:00
            // &p2=5/15/2020 23:59:59
            // &p3=AMM

            function formatDate(date: Date): string {
                if (isNaN(date.getTime())) {
                    return '';
                }

                const padStart = (value: number, maxLength: number = 2): string => value.toString().padStart(maxLength, '0');

                return 'mm/dd/yyyy hh:ii:ss'
                    .replace(/yyyy/g, padStart(date.getFullYear(), 4))
                    .replace(/dd/g, padStart(date.getDate()))
                    .replace(/mm/g, padStart(date.getMonth() + 1))
                    .replace(/hh/g, padStart(date.getHours()))
                    .replace(/ii/g, padStart(date.getMinutes()))
                    .replace(/ss/g, padStart(date.getSeconds()));
            }

            const isDevelopment = (window.location.hostname).indexOf('localhost') > -1 ||
                (window.location.hostname).indexOf('development') > -1;

            const reportUrl = isDevelopment
                ? 'https://development.municipalcitationsolutions.com/main/GPSGapReportExport.aspx'
                : 'https://vats.municipalcitationsolutions.com/main/GPSGapReportExport.aspx';

            const start = formatDate(dateRange.startDate);
            const end = formatDate(dateRange.endDate);
            const deviceName = trackedDevice.deviceName;

            const hrefUrl = `${reportUrl}?p1=${start}&p2=${end}&p3=${deviceName}`;

            Logger.Log(hrefUrl);

            link.setAttribute('href', hrefUrl);
        },

        locationChanged() {
            this.init();
        },

        async getMapOptions(): Promise<google.maps.MapOptions> {
            const mapOptions: google.maps.MapOptions = {
                zoom: 14,
                mapTypeId: 'roadmap',
                center: await this.getLatLngForLocation()
            };
            return mapOptions;
        },

        // endregion "Init methods"

        // region "Utility methods"

        getDateRange(selectedTimeFrame: TimeFrame): DateRange {
            const addHours = (date: Date, numHours: number) => {
                let result = new Date(date);
                result = new Date(result.setHours(result.getHours() + numHours));
                return result;
            };
            const addSeconds = (date: Date, numSeconds: number) => {
                let result = new Date(date);
                result = new Date(result.setSeconds(result.getSeconds() + numSeconds));
                return result;
            };
            const getDate = (date: Date) => {
                return new Date(date.setHours(0, 0, 0, 0));
            };

            const now: Date = new Date();
            let startDate: Date;
            let endDate: Date;

            switch (selectedTimeFrame) {
                case TimeFrame.LastHour:
                    return new DateRange(now, addHours(now, -1));
                case TimeFrame.Last2Hours:
                    return new DateRange(now, addHours(now, -2));
                case TimeFrame.Last5Hours:
                    return new DateRange(now, addHours(now, -5));
                case TimeFrame.Last10Hours:
                    return new DateRange(now, addHours(now, -10));
                case TimeFrame.Last24Hours:
                    return new DateRange(now, addHours(now, -24));
                case TimeFrame.DateRange:
                    startDate = getDate(this.selectedStartDate);
                    endDate = addSeconds(addHours(getDate(this.selectedEndDate), 24), -1);
                    return new DateRange(startDate, endDate);
                default:
                    startDate = getDate(now);
                    endDate = addSeconds(addHours(startDate, 24), -1);
                    return new DateRange(startDate, endDate);
            }
        },

        getMarkersFromDeviceTrackingData(trackingData: DeviceTrackingData[]): google.maps.Marker[] {
            const markers: google.maps.Marker[] = trackingData
                .sort((x, y) => x.timestamp > y.timestamp ? 1 : -1)
                .map(x => {
                    const position: google.maps.ReadonlyLatLngLiteral = {
                        lat: x.latitude,
                        lng: x.longitude
                    };

                    // without specifying the h:m:s it was only giving me back the date.
                    // also the value for fr-CA looks really weird to me.
                    // en-US: "Sep 9, 2019, 12:27:38 AM"
                    // fr-CA: "9 sept. 2019 00 h 27 min 38 s"
                    // at least it's clear the formatter is doing something...
                    const localeString = getLocaleWithoutDialect(this.$i18n.locale);
                    const locale = new Intl.DateTimeFormat(localeString, {
                        // https://devhints.io/wip/intl-datetime
                        // https://kazupon.github.io/vue-i18n/guide/datetime.html
                        year: 'numeric',
                        month: 'short',
                        day: 'numeric',
                        hour: 'numeric',
                        minute: 'numeric',
                        second: 'numeric'
                    });
                    const dateTimeString: string = locale.format(x.timestamp);
                    const title: string = `${x.deviceName}: ${dateTimeString}`;
                    const opts = {position, title};
                    return new google.maps.Marker(opts);
                });

            return markers;
        },

        // endregion "Utility methods"

        // region "Tracking option events"

        async onUpdateMap() {
            // set the map markers for the selected device and time frame
            const data: DeviceTrackingDataCollection = await this.getTrackingData(this.selectedDevice, this.selectedTimeFrame);

            this.markers = await this.getMarkersFromTrackingDataCollection(data);

            // center the map on the markers
            await this.setMapCenter(this.markers);

            // fill in the polylines between the markers
            // except the markers don't have time data on them, so we actually need one or more of:
            // DeviceTrackingData | DeviceTrackingData[] | DeviceTrackingDataCollection | undefined
            this.setPolylines(data);
        },

        setPolylines(dataCollection: DeviceTrackingDataCollection) {
            let polylines: google.maps.Polyline[] = [];

            try {
                // for each device in the collection,
                // create a single polyline from all its tracking data
                for (const deviceName in dataCollection) {
                    if (!dataCollection.hasOwnProperty(deviceName)) {
                        continue;
                    }

                    const deviceDataCollection = dataCollection[deviceName];

                    if (deviceDataCollection.length < 2) {
                        // no line unless there's a minimum of two points
                        continue;
                    }

                    const latLngArray: google.maps.LatLng[] = [];

                    deviceDataCollection
                        // order by timestamp ascending
                        .sort((x, y) => x.timestamp > y.timestamp ? 1 : -1)
                        // populate the latlng array
                        .forEach(d => {
                            const latLng = new google.maps.LatLng(d.latitude, d.longitude);
                            latLngArray.push(latLng);
                        });

                    const p = new google.maps.Polyline();
                    p.setPath(latLngArray);
                    polylines.push(p);
                }
            }
            catch (ex) {
                Logger.Log(ex);

                // if something goes wrong, just erase all the existing polylines
                polylines = [];
            }
            finally {
                const map = (this.$refs.map as any);
                map.clearPolylines();

                if (polylines.length > 0) {
                    map.addPolylines(polylines);
                }
            }
        },

        async setMapCenter(markers: google.maps.Marker[]) {
            const newCenter = await this.getMapCenterForMarkers(markers);

            // i hate this so much.  why can't i get a strong-typed "VatsGoogleMap" to work, leaving me to use "any"?
            (this.$refs.map as any).setCenter(newCenter);
        },

        async getMapCenterForMarkers(markers: google.maps.Marker[]): Promise<google.maps.LatLngLiteral> {
            if (markers.length === 0) {
                // return default center if there are no markers
                return await this.getLatLngForLocation();
            }

            const lat: number | undefined = markers[0].getPosition()?.lat();
            const lng: number | undefined = markers[0].getPosition()?.lng();

            if (lat === undefined || lng === undefined) {
                // return default center if either coordinate is undefined
                return await this.getLatLngForLocation();
            }

            const mapCenter: google.maps.LatLngLiteral = {lat, lng};
            return mapCenter;
        },

        async onPrintCurrentPage() {
            window.print();
        },

        async onSelectedDeviceChanged() {
            this.setRunReportLink(this.selectedDevice, this.getDateRange(this.selectedTimeFrame));
        },

        async onSelectedTimeFrameChanged() {
            this.setRunReportLink(this.selectedDevice, this.getDateRange(this.selectedTimeFrame));
        },

        async onSelectedStartDateChanged(date: Date) {
            if (date > this.selectedEndDate) {
                this.selectedEndDate = date;
            }

            this.setRunReportLink(this.selectedDevice, this.getDateRange(this.selectedTimeFrame));
        },
        async onSelectedEndDateChanged(date: Date) {
            if (date < this.selectedStartDate) {
                this.selectedStartDate = date;
            }

            this.setRunReportLink(this.selectedDevice, this.getDateRange(this.selectedTimeFrame));
        },

        // endregion "Tracking option events"

        // region "Get Tracking Data"

        setMarkerIcons(markers: google.maps.Marker[], defaultIcon: string, firstIcon?: string | undefined, lastIcon?: string | undefined): google.maps.Marker[] {
            const iconsResult = markers.map(x => {
                x.setIcon(defaultIcon);
                return x;
            });

            if (firstIcon !== undefined && iconsResult.length >= 2) {
                iconsResult[0].setIcon(firstIcon);
            }

            if (lastIcon !== undefined && iconsResult.length >= 2) {
                iconsResult[iconsResult.length - 1].setIcon(lastIcon);
            }

            return iconsResult;
        },

        async getTrackingData(selectedDevice: TrackedDevice, selectedTimeFrame: TimeFrame): Promise<DeviceTrackingDataCollection> {

            let result: DeviceTrackingDataCollection = {};

            if (!selectedDevice || !selectedTimeFrame) {
                return result;
            }

            try {
                if (selectedDevice.deviceID === allDevicesDeviceId) {
                    if (selectedTimeFrame === TimeFrame.CurrentLocation) {
                        result = await this.getAllDevicesCurrentLocation();
                    } else {
                        result = await this.getAllDeviceTrackingDataForTimeFrame(selectedTimeFrame);
                    }
                } else {
                    if (selectedTimeFrame === TimeFrame.CurrentLocation) {
                        result = await this.getSingleDeviceCurrentLocation(selectedDevice);
                    } else {
                        result = await this.getSingleDeviceForTimeFrame(selectedDevice, selectedTimeFrame);
                    }
                }
            } catch (e) {
                Logger.Log(e.message);
                result = {};
            }

            return result;
        },

        async getAllDevicesCurrentLocation(): Promise<DeviceTrackingDataCollection> {
            const url = `/${this.location}/HandheldAdmin/GetTrackingDataForAll`;
            const trackingData: DeviceTrackingData[] =
                (await VatsAPI.get<DeviceTrackingData[]>(url)).data
                    .map(x => {
                        x.timestamp = new Date(x.timestamp);
                        return x;
                    });
            return this.getTrackingDataCollectionFromArray(trackingData);
        },

        async getAllDeviceTrackingDataForTimeFrame(selectedTimeFrame: TimeFrame): Promise<DeviceTrackingDataCollection> {
            const dateRange: DateRange = this.getDateRange(selectedTimeFrame);

            const url = `/${this.location}/HandheldAdmin/GetTrackingDataForAllForDateRange`;
            const config: AxiosRequestConfig = {params: {startDate: dateRange.startDate, endDate: dateRange.endDate}};
            const trackingData: DeviceTrackingData[] =
                (await VatsAPI.get<DeviceTrackingData[]>(url, config)).data
                    .map(x => {
                        x.timestamp = new Date(x.timestamp);
                        return x;
                    });

            return this.getTrackingDataCollectionFromArray(trackingData);
        },

        async getSingleDeviceCurrentLocation(selectedDevice: TrackedDevice): Promise<DeviceTrackingDataCollection> {
            const url: string = `/${this.location}/HandheldAdmin/GetTrackingDataForDevice`;
            const deviceName: string = selectedDevice.deviceName;
            const config: AxiosRequestConfig = {params: {deviceName}};
            const trackingData: DeviceTrackingData = (await VatsAPI.get<DeviceTrackingData>(url, config)).data;
            trackingData.timestamp = new Date(trackingData.timestamp);
            return this.getTrackingDataCollectionFromArray([trackingData]);
        },

        async getSingleDeviceForTimeFrame(selectedDevice: TrackedDevice, selectedTimeFrame: TimeFrame): Promise<DeviceTrackingDataCollection> {
            try {
                const dateRange: DateRange = this.getDateRange(selectedTimeFrame);

                const url: string = `/${this.location}/HandheldAdmin/GetTrackingData`;
                const config: AxiosRequestConfig = {
                    params: {
                        deviceName: selectedDevice.deviceName,
                        startDate: dateRange.startDate,
                        endDate: dateRange.endDate
                    }
                };
                const trackingData: DeviceTrackingData[] =
                    (await VatsAPI.get<DeviceTrackingData[]>(url, config)).data
                        .map(x => {
                            x.timestamp = new Date(x.timestamp);
                            return x;
                        });

                const collection = await this.getTrackingDataCollectionFromArray(trackingData);

                return collection;
            } catch (ex) {
                Logger.Log(ex);
                return {};
            }
        },

        async getTrackingDataCollectionFromArray(data: DeviceTrackingData[]) {
            // group by deviceName
            const collection: DeviceTrackingDataCollection = data
                .reduce((g: DeviceTrackingDataCollection, dtd: DeviceTrackingData) => {
                    g[dtd.deviceName] = g[dtd.deviceName] || []; // Check the value exists, if not assign a new array
                    g[dtd.deviceName].push(dtd); // Push the new value to the array
                    return g; // Very important! you need to return the value of g or it will become undefined on the next pass
                }, {});

            // order by date within each key
            for (const key in collection) {
                if (!collection.hasOwnProperty(key)) {
                    continue;
                }

                const orderedValues = collection[key].sort((x, y) => x.timestamp > y.timestamp ? 1 : -1);

                collection[key] = orderedValues;
            }

            return collection;
        },

        async getMarkersFromTrackingDataCollection(dataCollection: DeviceTrackingDataCollection): Promise<google.maps.Marker[]> {
            let allDeviceMarkers: google.maps.Marker[] = [];

            let isCollectionTrackingDeviceMovement: boolean = false;
            for (const deviceName in dataCollection) {
                if (!dataCollection.hasOwnProperty(deviceName)) {
                    continue;
                }

                if (dataCollection[deviceName].length > 1) {
                    isCollectionTrackingDeviceMovement = true;
                    break;
                }
            }

            for (const deviceName in dataCollection) {
                if (!dataCollection.hasOwnProperty(deviceName)) {
                    continue;
                }

                // get the data for this device
                let data: DeviceTrackingData[] = dataCollection[deviceName];

                if (data.length === 0) {
                    continue;
                }

                // order the data by timestamp (should already be sorted though)
                data = data.sort((x, y) => x.timestamp > y.timestamp ? 1 : -1);

                // get the markers
                let currentDeviceMarkers: google.maps.Marker[] = this.getMarkersFromDeviceTrackingData(data);

                // set the marker icons
                if (isCollectionTrackingDeviceMovement) {
                    currentDeviceMarkers = this.setMarkerIcons(currentDeviceMarkers, TRACKING_ICON_DEFAULT, TRACKING_ICON_FIRST, TRACKING_ICON_LAST);
                }
                else {
                    currentDeviceMarkers = this.setMarkerIcons(currentDeviceMarkers, DEFAULT_ICON);
                }

                // add the new markers to the collection
                allDeviceMarkers = allDeviceMarkers.concat(currentDeviceMarkers);
            }

            return allDeviceMarkers;
        },

        // endregion "Get Tracking Data"

        async getTrackedDevices(): Promise<TrackedDevice[]> {
            const url = `/${this.location}/HandheldAdmin/GetTrackedDeviceList`;
            const trackedDevices = (await VatsAPI.get<TrackedDevice[]>(url)).data;
            const allDevicesDeviceItem: TrackedDevice = {
                deviceName: 'All Devices',
                deviceID: allDevicesDeviceId
            };
            return [allDevicesDeviceItem, ...trackedDevices];
        },

        async getLatLngForLocation(): Promise<google.maps.LatLngLiteral> {
            const url: string = `/${this.location}/LotMaintenance/GetLatLongForLocation`;
            const latLongString: string = (await VatsAPI.get<string>(url)).data;
            const latLongArr: string[] = latLongString.split(',');
            const latLongObj: google.maps.LatLngLiteral = {
                lat: parseFloat(latLongArr[0]),
                lng: parseFloat(latLongArr[1])
            };
            return latLongObj;
        }
    }
});

export default VATSTrackingAdmin;
